import { useEffect } from "react";
import SellerDashboard from "components/SellerDashboard";
import Main from "layouts/Main";
import { useAppDispatch } from "store";
import { setFooterShow } from "store/slices/layoutSlice";

function Dashboard() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setFooterShow(true));
  }, [dispatch]);

  return (
    <Main namePage="ภาพรวมร้านค้า" subNamePage="">
      <div className="layout-content">
        <SellerDashboard />
      </div>
    </Main>
  );
}

export default Dashboard;
